import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { Section, SectionTitle, InfoGrid, InfoItem } from './ProfileStyles';

/**
 * Contato de correspondência do usuário (e-mail/celular do endereço marcado
 * como correspondência). Pode ser null se nenhum endereço foi marcado como
 * correspondência ou se não há cadastro de Pessoa vinculado ao login.
 *
 * @param {Object|null} props.contato - { email, celular }
 */
export const ContactInfo = ({ contato }) => (
  <Section>
    <SectionTitle>
      <FaEnvelope /> Contato
    </SectionTitle>

    {contato ? (
      <InfoGrid>
        <InfoItem>
          <label>E-mail</label>
          <span>{contato.email || 'Não informado'}</span>
        </InfoItem>

        <InfoItem>
          <label>Celular</label>
          <span>{contato.celular || 'Não informado'}</span>
        </InfoItem>
      </InfoGrid>
    ) : (
      <InfoGrid>
        <InfoItem>
          <span>Nenhum contato de correspondência cadastrado</span>
        </InfoItem>
      </InfoGrid>
    )}
  </Section>
);
